import { render, staticRenderFns } from "./SaveSearchCombo.vue?vue&type=template&id=05542a45&scoped=true"
import script from "./SaveSearchCombo.vue?vue&type=script&lang=js"
export * from "./SaveSearchCombo.vue?vue&type=script&lang=js"
import style0 from "./SaveSearchCombo.vue?vue&type=style&index=0&id=05542a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05542a45",
  null
  
)

export default component.exports